import React from "react";

type PatientStatusWidgetRuntime = {
  canRenderExternalRegisterClinical: boolean;
  canOpenExternalRegisterSecureDetails: boolean;
  currentEncounterId?: string;
  onOpenExternalRegisterDetails?: (patientId: string, alertId?: string) => void;
};

const defaultRuntime: PatientStatusWidgetRuntime = {
  canRenderExternalRegisterClinical: false,
  canOpenExternalRegisterSecureDetails: false,
};

const PatientStatusWidgetRuntimeContext = React.createContext<PatientStatusWidgetRuntime>(defaultRuntime);

export const PatientStatusWidgetRuntimeProvider: React.FC<{
  value: PatientStatusWidgetRuntime;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <PatientStatusWidgetRuntimeContext.Provider value={value}>
    {children}
  </PatientStatusWidgetRuntimeContext.Provider>
);

export const usePatientStatusWidgetRuntime = () => React.useContext(PatientStatusWidgetRuntimeContext);
